import api, { currentAdapter } from './axiosClient'
import { AxiosResponse } from 'axios'
import {
	AuthProviderLoginUrlResponse,
	ForgetPasswordRequest,
	LoginRequest,
	LoginResponse,
	User,
	UserSignUpRequest,
	ValidateThirdPartyTokenRequest,
	VerifyEmailOtpRequest,
	VerifyEmailOtpResponse,
} from '../../proto/generated/identity'

export const getLoginUrl = async (args: { body: any }): Promise<AuthProviderLoginUrlResponse> => {
	return await currentAdapter.getLoginUrl(args.body)
}

export const LoginWithMail = async (args: { body: LoginRequest }): Promise<LoginResponse> => {
	return await currentAdapter.loginWithMail(args.body)
}

export const SignUpWithMail = async (args: { userSignUpRequest: UserSignUpRequest }): Promise<LoginResponse> => {
	return await currentAdapter.signUpWithMail(args.userSignUpRequest)
}

export const SendEmailOtp = async (args: {
	body: { email: string }
	purpose?: string
}): Promise<AxiosResponse> => {
	return await currentAdapter.sendEmailOtp(args.body.email, { purpose: args.purpose })
}

export const VerifyEmailOtp = async (args: {
	email: string
	requestId: string
	verificationOtp: string
}): Promise<VerifyEmailOtpResponse> => {
	const body = VerifyEmailOtpRequest.fromPartial({
		email: args.email,
		requestId: args.requestId,
		verificationOtp: args.verificationOtp,
	})
	const res = await api.post(`/user/verify-email-otp`, JSON.stringify(VerifyEmailOtpRequest.toJSON(body)), {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/x-protobuf',
		},
		responseType: 'arraybuffer',
	})
	return VerifyEmailOtpResponse.decode(new Uint8Array(res.data))
}

export const ForgetPassword = async (args: { body: ForgetPasswordRequest }): Promise<User> => {
	return await currentAdapter.forgetPassword(args.body)
}

export const validateToken = async (args: { body: ValidateThirdPartyTokenRequest }): Promise<LoginResponse> => {
	return await currentAdapter.validateToken(args.body)
}

export const logout = (): void => {
	currentAdapter.logout()
}
